/* eslint-disable no-shadow */

enum MatchStatus {
  // These values correspond to those in config.reference_match_status
  Approved = 1,
  NeedToBeApproved = 2,
  Rejected = 3,
  Disputed = 4,
  Unmatched = 5,
  OnHold = 6,
}

enum MatchType {
  // These values correspond to those in config.reference_match_type
  Deterministic = 1,
  Fuzzy = 2,
  Manual = 3,
  ETLGenerated = 4,
}

const MATCH_LIST_STATUSES = [
  'Approved',
  'Rejected',
];

const MATCH_ACTION_STATUSES = [
  'Need to be approved',
  'Disputed',
  'Unmatched',
  'On hold',
];

export {
  MatchStatus,
  MatchType,
  MATCH_LIST_STATUSES,
  MATCH_ACTION_STATUSES,
};
